import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const zeitraumGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const vondatum = route.queryParamMap.get('vondatum');
  const bisdatum = route.queryParamMap.get('bisdatum');

  if (!vondatum || !bisdatum)
    return router.createUrlTree(['/rohstoffbilanz', 'zeitraum-eingabe']);

  return true;
};
